import { SafeImage } from '@/components/common/safe-image';
import useGroupInfo from '@/hooks/groups/use-group-info';
import cn from '@/utils/merge-class-names';
import { GroupImageUploadButton } from './group-image-upload-button';

type Props = {
  groupId: number;
  className?: string;
};

export default function GroupDetailImage({ groupId, className }: Props) {
  const { data: groupInfo, canManage } = useGroupInfo(groupId);

  return groupInfo?.GroupData ? (
    <div className='relative'>
      <SafeImage
        src={groupInfo.GroupData.GroupImg}
        size={[64, 64]}
        className={cn('size-16 rounded-full bg-cover', className)}
      />
      {canManage && <GroupImageUploadButton groupId={groupId} />}
    </div>
  ) : null;
}
